(function () {
  var lang = window.AriseoLang;
  if (!lang) return;

  var SEARCH_FROM = 7;

  function utmParams() {
    var params = new URLSearchParams();
    new URLSearchParams(window.location.search).forEach(function (value, key) {
      if (key.indexOf('utm_') === 0) params.set(key, value);
    });
    return params;
  }

  // Remember the pick here, and on the other store too when the visitor crosses over (?ar_pick, read by
  // snippets/language-routing.liquid). UTM parameters travel along, so a QR visit keeps its source.
  function go(code, site) {
    lang.save(code);
    var params = utmParams();
    if (site && site !== lang.site) {
      params.set('ar_pick', code);
      window.location.href = lang.sites[site] + '/?' + params.toString();
      return;
    }
    var url = lang.urlFor(code, params);
    if (url) window.location.href = url;
  }

  // Ask a store's tokenless Storefront API (open to any origin) about its markets.
  function storefront(site, query) {
    return fetch(lang.sites[site] + '/api/2025-07/graphql.json', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ query: query }),
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        return data.data.localization;
      });
  }

  // 'ZH_CN' → 'zh-CN', as Liquid writes it.
  function languageCode(isoCode) {
    var parts = isoCode.split('_');
    return parts[0].toLowerCase() + (parts[1] ? '-' + parts[1] : '');
  }

  function otherSites() {
    return Object.keys(lang.sites).filter(function (site) {
      return site !== lang.site;
    });
  }

  // Languages published on the other store, kept for the session so each page does not ask again.
  function otherLanguages() {
    var KEY = 'ariseo_other_languages';
    try {
      var cached = JSON.parse(sessionStorage.getItem(KEY));
      if (cached) return Promise.resolve(cached);
    } catch (e) {}
    if (!window.fetch) return Promise.resolve([]);
    return Promise.all(
      otherSites().map(function (site) {
        return storefront(site, '{ localization { availableLanguages { isoCode endonymName } } }')
          .then(function (localization) {
            return localization.availableLanguages.map(function (language) {
              return { code: languageCode(language.isoCode), name: language.endonymName, site: site };
            });
          })
          .catch(function () {
            return [];
          });
      })
    ).then(function (lists) {
      var languages = [].concat.apply([], lists);
      try {
        if (languages.length) sessionStorage.setItem(KEY, JSON.stringify(languages));
      } catch (e) {}
      return languages;
    });
  }

  function bindLink(link) {
    link.addEventListener('click', function (event) {
      var code = link.dataset.languageCode;
      event.preventDefault();
      if (code === lang.current && link.dataset.site === lang.site) {
        lang.save(code);
        var details = link.closest('details');
        if (details) details.open = false;
        return;
      }
      go(code, link.dataset.site);
    });
  }

  document.querySelectorAll('[data-language-code]').forEach(bindLink);

  // Add the other store's languages to every switcher, skipping any this store already has.
  otherLanguages().then(function (languages) {
    document.querySelectorAll('[data-language-list]').forEach(function (list) {
      var template = list.querySelector('[data-language-code]');
      if (!template) return;
      languages.forEach(function (language) {
        if (list.querySelector('[data-language-code="' + language.code + '"]')) return;
        var link = template.cloneNode(false);
        link.removeAttribute('aria-current');
        link.href = lang.sites[language.site] + '/?ar_pick=' + encodeURIComponent(language.code);
        link.hreflang = language.code;
        link.lang = language.code;
        link.dataset.languageCode = language.code;
        link.dataset.site = language.site;
        link.textContent = language.name;
        bindLink(link);
        list.appendChild(link);
      });
    });
    document.querySelectorAll('[data-language-switcher]').forEach(setUpSearch);
    // The drawer row turns into a grid once it would wrap.
    document.querySelectorAll('.language-switcher--drawer').forEach(function (row) {
      row.classList.toggle('language-switcher--many', row.querySelectorAll('[data-language-code]').length >= SEARCH_FROM);
    });
  });

  // A search above the dropdown once it lists many languages.
  function setUpSearch(details) {
    var search = details.querySelector('[data-language-search]');
    var links = Array.prototype.slice.call(details.querySelectorAll('[data-language-code]'));
    if (!search || links.length < SEARCH_FROM) return;
    search.hidden = false;
    search.addEventListener('input', function () {
      var query = search.value.trim().toLowerCase();
      links.forEach(function (link) {
        var text = (link.textContent + ' ' + link.dataset.languageCode).toLowerCase();
        link.hidden = !!query && text.indexOf(query) === -1;
      });
    });
    search.addEventListener('keydown', function (event) {
      if (event.key !== 'Enter') return;
      event.preventDefault();
      var first = links.filter(function (link) {
        return !link.hidden;
      })[0];
      if (first) first.click();
    });
    details.addEventListener('toggle', function () {
      if (!details.open) return;
      search.value = '';
      search.dispatchEvent(new Event('input'));
      search.focus();
    });
  }

  document.addEventListener('click', function (event) {
    document.querySelectorAll('[data-language-switcher][open]').forEach(function (details) {
      if (!details.contains(event.target)) details.open = false;
    });
  });

  document.addEventListener('keyup', function (event) {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('[data-language-switcher][open]').forEach(function (details) {
      details.open = false;
      details.querySelector('summary').focus();
    });
  });

  // First visit: a "Shipping to" popup (sections/shipping-popup.liquid). It lists every country the two
  // stores sell to, read from their Storefront APIs, so a country or language added in Shopify shows up
  // on its own. A pick moves to the store that sells there, in the country's language when that store
  // has it, else English, and sets the country on that store when it is this one.
  if ((window.Shopify && window.Shopify.designMode) || lang.saved()) return;
  if (typeof HTMLDialogElement !== 'function' || !window.fetch) return;

  var FEATURED_MAX = 6;

  function detectedCountry() {
    var controller = window.AbortController ? new AbortController() : null;
    var timer = setTimeout(function () {
      if (controller) controller.abort();
    }, 2000);
    return fetch('/browsing_context_suggestions.json', controller ? { signal: controller.signal } : {})
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        var country = data && data.detected_values && data.detected_values.country;
        return country ? String(country.handle).toUpperCase() : null;
      })
      .catch(function () {
        return null;
      })
      .finally(function () {
        clearTimeout(timer);
      });
  }

  function loadPopup() {
    var root = (lang.roots[lang.current] || '/').replace(/\/$/, '');
    return fetch(root + '/?section_id=shipping-popup')
      .then(function (response) {
        if (!response.ok) throw new Error(response.status);
        return response.text();
      })
      .then(function (html) {
        return new DOMParser().parseFromString(html, 'text/html').querySelector('.shipping-popup');
      });
  }

  // Countries one store sells to, each with the languages it is published in there.
  function storeCountries(site) {
    return storefront(site, '{ localization { availableCountries { isoCode name availableLanguages { isoCode } } } }')
      .then(function (localization) {
        return localization.availableCountries.map(function (country) {
          return {
            code: country.isoCode,
            name: country.name,
            site: site,
            languages: country.availableLanguages.map(function (language) {
              return languageCode(language.isoCode);
            }),
          };
        });
      })
      .catch(function () {
        return [];
      });
  }

  // This store first, so a country both stores sell to stays here.
  function allCountries() {
    var sites = [lang.site].concat(otherSites());
    return Promise.all(sites.map(storeCountries)).then(function (lists) {
      var seen = {};
      var locale = document.documentElement.lang || 'en';
      var names = null;
      try {
        names = new Intl.DisplayNames([locale], { type: 'region' });
      } catch (e) {}
      return [].concat
        .apply([], lists)
        .filter(function (country) {
          if (seen[country.code]) return false;
          seen[country.code] = true;
          return true;
        })
        .map(function (country) {
          country.name = (names && names.of(country.code)) || country.name;
          return country;
        })
        .sort(function (a, b) {
          return a.name.localeCompare(b.name, locale);
        });
    });
  }

  // The country's main language when its store has it (Intl guesses JP→ja, TW→zh, TH→th), else English.
  function languageOf(country) {
    var main = null;
    try {
      main = new Intl.Locale('und-' + country.code).maximize().language;
    } catch (e) {}
    var match = country.languages.filter(function (code) {
      return code.split('-')[0] === main;
    })[0];
    if (match) return match;
    return country.languages.indexOf('en') !== -1 ? 'en' : country.languages[0];
  }

  // This page's path without the locale prefix, plus the UTM parameters.
  function returnTo() {
    var currentRoot = lang.roots[lang.current] || '/';
    var path = window.location.pathname;
    if (currentRoot !== '/' && path.indexOf(currentRoot) === 0) path = path.slice(currentRoot.length) || '/';
    var query = utmParams().toString();
    return path + (query ? '?' + query : '');
  }

  function countryItem(country, className) {
    var item = document.createElement('li');
    item.dataset.name = (country.name + ' ' + country.code).toLowerCase();
    var button = document.createElement('button');
    button.type = 'button';
    button.className = className;
    button.dataset.country = country.code;
    button.textContent = country.name;
    item.appendChild(button);
    return item;
  }

  function showPopup(dialog, countries, detected) {
    var form = dialog.querySelector('.shipping-popup__form');
    var search = dialog.querySelector('[data-search]');
    var empty = dialog.querySelector('[data-empty]');
    var featured = dialog.querySelector('[data-featured]');
    var list = dialog.querySelector('[data-list]');
    var byCode = {};

    countries.forEach(function (country) {
      byCode[country.code] = country;
    });
    // The visitor's own country goes first.
    var own = byCode[detected];
    if (own) {
      countries.splice(countries.indexOf(own), 1);
      countries.unshift(own);
    }

    var rest = featured.lastElementChild;
    countries.slice(0, FEATURED_MAX).forEach(function (country) {
      featured.insertBefore(countryItem(country, 'shipping-popup__featured-link'), rest);
    });
    var items = countries.map(function (country) {
      return list.appendChild(countryItem(country, 'shipping-popup__country'));
    });

    function step(name) {
      dialog.querySelectorAll('[data-step]').forEach(function (panel) {
        panel.hidden = panel.dataset.step !== name;
      });
      if (name === 'all') {
        search.focus();
      } else {
        search.value = '';
        filter();
        dialog.focus();
      }
    }

    function filter() {
      var query = search.value.trim().toLowerCase();
      var shown = 0;
      items.forEach(function (item) {
        var match = !query || item.dataset.name.indexOf(query) !== -1;
        item.hidden = !match;
        if (match) shown++;
      });
      empty.hidden = shown > 0;
    }

    function close() {
      document.documentElement.classList.remove('shipping-popup-open');
      dialog.close();
      dialog.remove();
    }

    // Closing without a pick keeps the page as it is and never asks again.
    function dismiss() {
      lang.save(lang.current);
      close();
    }

    function pick(code) {
      var country = byCode[code];
      var language = languageOf(country);

      if (country.site !== lang.site) {
        go(language, country.site);
        return;
      }

      lang.save(language);
      if (language === lang.current && window.Shopify && code === window.Shopify.country) {
        close();
        return;
      }
      form.querySelector('[name="country_code"]').value = code;
      form.querySelector('[name="language_code"]').value = language;
      form.querySelector('[name="return_to"]').value = returnTo();
      form.submit();
    }

    dialog.addEventListener('click', function (event) {
      var target = event.target.closest('button');
      if (!target) return;
      if (target.hasAttribute('data-close')) dismiss();
      else if (target.dataset.stepTo) step(target.dataset.stepTo);
      else if (target.dataset.country) pick(target.dataset.country);
    });
    search.addEventListener('input', filter);
    search.addEventListener('keydown', function (event) {
      if (event.key !== 'Enter') return;
      event.preventDefault();
      var first = items.filter(function (item) {
        return !item.hidden;
      })[0];
      if (first) pick(first.querySelector('[data-country]').dataset.country);
    });
    dialog.addEventListener('cancel', function (event) {
      event.preventDefault();
      dismiss();
    });

    document.body.appendChild(dialog);
    document.documentElement.classList.add('shipping-popup-open');
    dialog.showModal();
    // Focus the popup itself: keyboard users tab straight to the list, nobody sees a ring on open.
    dialog.focus();
  }

  Promise.all([loadPopup(), allCountries(), detectedCountry()])
    .then(function (results) {
      // The visitor may have picked from the header switcher while the popup loaded.
      if (results[0] && results[1].length && !lang.saved()) {
        showPopup(document.importNode(results[0], true), results[1], results[2]);
      }
    })
    .catch(function () {});
})();
